var map = {
	"./race_track_bg_continental.png": 1983,
	"./race_track_bg_global.png": 9195,
	"./race_track_bg_regional.png": 3513,
	"./race_track_bg_saucer.png": 931,
	"./race_track_bg_transcontinental.png": 171
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7149;